import { axios, BaseApiUrl } from '../axios_config';

// 获取移动端库存列表
export const getInventoryBatchList = params =>{
    return axios.get(`${BaseApiUrl}/InventoryQuery/GetInventoryBatchList`, { params }).then(res => res.data);
}

// 获取移动端库存总数
export const getInventoryBatchtotal = params =>{
    return axios.get(`${BaseApiUrl}/InventoryQuery/GetInventoryBatchtotal`, { params }).then(res => res.data);
}

// 获取移动端库位
export const getWarehouseLocation = params =>{
    return axios.get(`${BaseApiUrl}/InventoryQuery/GetWarehouseLocation`, { params }).then(res => res.data);
}
